// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xBaseTheme } from "@steiner/XDL/types";
import { color, ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        border: "rectangle",
        sizeVariant: "default",
        backgroundColor: "common.ui15",
        labelProps: {
            mergeCss: true,
            size: 12,
            weight: fontConfig.weight.semiBold,
            css: css`
                letter-spacing: 0;
                line-height: 17px;
                min-height: initial;
            `,
        },
        hintProps: {
            mergeCss: true,
            size: 14,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        errorProps: {
            mergeCss: true,
            color: "danger.main",
            size: 14,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        cssOverrides: {
            formField: css`
                input,
                textarea,
                select {
                    transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                    &:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                        &::placeholder {
                            font-style: italic;
                            max-width: 100%;
                            color: ${color("common.ui5")};
                            font-weight: 400;
                        }
                    }
                    &:not(.react-datetime-picker__inputGroup__input):disabled {
                        border: 1px solid ${color("common.ui2", 0.33)};
                        background: ${color("common.ui2", 0.33)};
                        &::placeholder {
                            font-style: normal;
                            color: ${color("common.ui5")};
                            font-weight: 400;
                        }
                    }
                }

                input,
                select {
                    &:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                        text-overflow: ellipsis;
                        &::placeholder {
                            font-style: italic;
                            max-width: 100%;
                            color: ${color("common.ui5")};
                            font-weight: 400;
                        }
                    }
                }

                ${({ error }: any) =>
                    !error &&
                    css`
                        input,
                        textarea,
                        select {
                            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                            &:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]) {
                                &:hover:not(:disabled) {
                                    border: 1px solid transparent;
                                }
                                &:focus:not(:disabled) {
                                    border: 1px solid ${color("common.ui10")};
                                }
                            }
                        }
                    `}
            `,
        },
    },
} as xBaseTheme["formField"];
